document.addEventListener('DOMContentLoaded', function () {
    setTimeout(function () {
        const buttons = document.querySelectorAll('.btn--underline.btn--small');
        
        if (buttons.length > 0) {
            console.log("Button elements found");
        } else {
            console.log("No button elements found");
        }

        buttons.forEach(function (button) {
            button.style.textDecoration = 'none';
            button.addEventListener('mouseover', function () {
                button.style.textDecoration = 'none';
            });
            button.addEventListener('focus', function () {
                button.style.textDecoration = 'none';
            });
        });
    }, 500);  // Delay by 500ms to allow DOM to fully load
});
